import type { MessageHandlerDeps } from '../../../routing/message-handler-deps.js';
import type { ApiToBridgeAgentConfigMessage } from '../../../types/api-to-bridge-messages.js';

export function handleBridgeAgentConfig(msg: ApiToBridgeAgentConfigMessage, { acpManager }: MessageHandlerDeps): void {
  if (!Array.isArray(msg.agents) || (msg.agents as unknown[]).length === 0) return;
  acpManager.setPreferredAgentType((msg.agents as Array<{ type: string }>)[0].type);
}
